var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachmentBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.93 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#263d50;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Csatolm\\xE1ny"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.23,10.92,12,24.1A6.47,6.47,0,1,1,2.89,15l3.19-3.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22,
    y1: 2.99,
    x2: 22,
    y2: 2.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.56,18.09l8-8,1-1A4.19,4.19,0,0,0,22,3h0a5.08,5.08,0,0,0-.38-.43l-.44-.44c-1.8-1.79-4.18-1.27-6,.52L6.16,11.69l-.08.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.59,10.07l-8,8-1.45,1.46A2.5,2.5,0,1,1,7.58,16l8.87-8.87"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentBlack);
export default __webpack_public_path__ + "static/media/attachmentBlack.049c9cd44afba5c2e09c4c95eb77bc87.svg";
export { ForwardRef as ReactComponent };